import { z } from "zod";

export const contactRequestSchema = z.object({
  salonId: z.string().min(1),
  subject: z.string().min(1),
  name: z.string().min(1),
  email: z.string().email(),
  phoneNumber: z.string().optional().default(""),
  message: z.string().min(1).max(5000),
});

export const contactResponseSchema = z.object({
  success: z.boolean(),
});

export type ContactRequest = z.infer<typeof contactRequestSchema>;
export type ContactResponse = z.infer<typeof contactResponseSchema>;
